export const TranslationKeys = {
  ProvablyFairness: 'PROVABLY_FAIRNESS',
  Time: 'TIME',
  GameId: 'GAME_ID',
  Count: 'COUNT',
  TotalBet: 'TOTAL_BET',
  Game: 'GAME',
  PlayForReal: 'PLAY_FOR_REAL',
  Music: 'MUSIC',
  Sound: 'SOUND',
  WinterMode: 'WINTER_MODE',
  BlackMode: 'BLACK_MODE',
  PlayerId: 'PLAYER_ID',
  BetType: 'BET_TYPE',
  LastRounds: 'LAST_ROUNDS',
  Balance: 'BALANCE',
  All: 'ALL',
  Win: 'WIN',
  Lose: 'LOSE',
  MaximumWin: 'MAXIMUM_WIN',
  MinimumBet: 'MINIMUM_BET',
  MaximumBet: 'MAXIMUM_BET',
  Seconds: 'SECONDS',
  PlayNow: 'PLAY_NOW',
  Demo: 'DEMO',
  Play: 'PLAY',
  ResultId: 'RESULT_ID',
  TopWins: 'TOP_WINS',
  History: 'HISTORY',
  Result: 'RESULT',
  Results: 'RESULTS',
  LiveBets: 'LIVE_BETS',
  Statistics: 'STATISTICS',
  Bet: 'BET',
  Info: 'INFO',
  Chat: 'CHAT',
  YourConnectionLost: 'YOUR_CONNECTION_LOST',
  YourSessionWasInterrupted: 'YOUR_SESSION_WAS_INTERRUPTED',
  PleaseWait: 'PLEASE_WAIT',
  PleaseRefreshPage: 'PLEASE_REFRESH_PAGE',
  Reconnect: 'RECONNECT',
  Pf: 'PF',
  Min: 'MIN',
  ReBet: 'REBET',
  Repeat: 'REPEAT',
  CheckHashCode: 'CHACK_HASH_CODE',
  MyBets: 'MY_BETS',
  TopWinners: 'TOP_WINNERS',
  Bonus: 'BONUS',
  UnderMaintenanceInGame: 'UNDER_MAINTENANCE_IN_GAME',
  Odd: 'ODD',
  Odds: 'ODDS',
  RoundId: 'ROUND_ID',
  YouWin: 'YOU_WIN',
  AboutHashCode: 'ABOUT_HASH_CODE',
  Check: 'CHECK',
  Key: 'KEY',
  Salt: 'SALT',
  HashCode: 'HASH_CODE',
  Fairness: 'FAIRNESS',
  Help: 'HELP',
  Lobby: 'LOBBY',
  Bets: 'BETS',
  Ok: 'OK',
  FreeBet: 'FREE_BET',
  Connecting: 'CONNECTING',
  AutoBet: 'AUTO_BET',
  BetsAreClosing: 'BETS_ARE_CLOSING',
  PlaceYourBets: 'PLACE_YOUR_BETS',
  BetsAreClosed: 'BETS_ARE_CLOSED',
  Symbol: 'SYMBOL',
  GameRulesP1: 'GAME_RULES_P1',
  GameRulesP2: 'GAME_RULES_P2',
  GameRulesP3: 'GAME_RULES_P3',
  GameRulesP4: 'GAME_RULES_P4',
  GameRulesP5: 'GAME_RULES_P5',
  GameRulesP6: 'GAME_RULES_P6',
  GameRulesP7: 'GAME_RULES_P7',
  GameRulesP8: 'GAME_RULES_P8',
  GameRulesP9: 'GAME_RULES_P9',
  GameRulesP10: 'GAME_RULES_P10',
  GameRulesP11: 'GAME_RULES_P11',
  GameRulesP12: 'GAME_RULES_P12',
  GameRulesP13: 'GAME_RULES_P13',
  GameRulesP14: 'GAME_RULES_P14',
  GameRulesP15: 'GAME_RULES_P15',
  GameRulesP16: 'GAME_RULES_P16',
  GameRulesP17: 'GAME_RULES_P17',
  GameRulesP18: 'GAME_RULES_P18',
  CancelationMessage1: 'CANCELATION_MESSAGE_1',
  MalfunctionMessage2: 'MALFUNCTION_MESSAGE_2',
  UpTo: 'UP_TO',
  SlowConnection: 'SLOW_CONNECTION',
  Rtp: 'RTP',
  LoaderText: 'LOADER_TEXT',
  Me: 'ME',
  AdvertisingText: 'ADVERTISING_TEXT',
  FairnessP1: 'FAIRNESS_P1',
  FairnessP2: 'FAIRNESS_P2',
  FairnessP3: 'FAIRNESS_P3',
  FairnessP4: 'FAIRNESS_P4',
  FairnessP5: 'FAIRNESS_P5',
  FairnessP6: 'FAIRNESS_P6',
  FairnessP7: 'FAIRNESS_P7',
  FairnessP8: 'FAIRNESS_P8',
  FairnessP9: 'FAIRNESS_P9',
  FairnessP10: 'FAIRNESS_P10',
  FairnessP11: 'FAIRNESS_P11',
  FairnessP12: 'FAIRNESS_P12',
  User: 'USER',
  Amount: 'AMOUNT',
  Soon: 'SOON',
  About: 'ABOUT',
  GameTypes: 'GAME_TYPES',
};
